/** idwiz navy register — remediation summary surfaces */
export const NAVY = {
  bg: "#0B1220",
  panel: "#121B2B",
  panel2: "#16213A",
  line: "#24304A",
  line2: "#2E3A57",
  fg: "#ECF0F7",
  mut: "#9AA7BD",
  faint: "#6B788F",
  crit: "#FF5964",
  high: "#FF9F45",
  med: "#F5C842",
  low: "#6B7688",
  ok: "#2FC9AB",
  elec: "#5B8CFF",
};
